import {
  SubscriptionDetailsIntl,
  SubscriptionDetailsTableIntl,
} from 'types/i18n';

const tableIntl: SubscriptionDetailsTableIntl = {
  descriptionTitle: 'Описание',
  productsTitle: 'Продукты',
  paymentsTitle: 'Платежи',

  clientNameLabel: 'Покупатель',
  amountLabel: 'Сумма, $',
  createdAtLabel: 'Дата создания',
  idLabel: 'ID',
  periodLabel: 'Период, мес',
};

export const subscriptionDetailsIntl: SubscriptionDetailsIntl = {
  title(id: number) {
    return `Подписка №${id}`;
  },
  table: tableIntl,
};
